"use client";
import { LoremIpsum } from "lorem-ipsum";
import { ComponentTypes, ISettings } from "./Editor/types";
import { get, has, keys, List, uniq, set } from "lodash";
import { listAncestors } from "./V2Editor/actions";

import React, { useRef, useState, useLayoutEffect } from "react";
import { PageContent } from "./Page/Page";
import { PageContext } from "./Page/PageContext";
import { MobileState } from "./MobileResponsiveToggle/types";
import ReactDOMServer from "react-dom/server";

export const lorem: any = new LoremIpsum({
  sentencesPerParagraph: {
    max: 4,
    min: 3,
  },
  wordsPerSentence: {
    max: 16,
    min: 4,
  },
});

const objectDeepKeys = (obj: any): string[] => {
  if (obj == null || typeof obj !== "object") {
    return [];
  }
  return keys(obj)
    .filter((key) => obj[key] instanceof Object)
    .flatMap((key) => [
      key,
      ...objectDeepKeys(obj[key]).map((k) => `${key}.${k}`),
    ]);
};

// export const generateFontList = (content: ISettings[]): string[] => {
//   if (!Array.isArray(content) || content.length === 0) {
//     return [];
//   }
//   return uniq(
//     objectDeepKeys(content)
//       .filter((itm) => itm.includes(".fontFamily"))
//       .map((key) => get(content, key))
//       .filter((font): font is string => typeof font === "string")
//   );
// };

interface FontItem {
  fontFamily?: string;
  [key: string]: any;
}

export const generateFontList = (content: ISettings[] = []) => {
  // const toProcess = pages.map((itm) => itm.content || false);

  // console.log({ pages: pages.map(itm => keys(itm)), toProcess: toProcess.map(({ slug }) => slug || false) })
  // console.log("****************\n\n", pages.filter(itm => has(itm.content)).map(itm => itm.slug), "\n\n*******************")
  // console.log("****************\n\n", pages.map(itm => ({ slug: itm.slug, keys: keys(itm), content: itm.content ? itm.content.length : 0 })), "\n\n*******************")

  let fontList: List<any> | null | undefined = [];
  // console.log("Fonts from content", content);
  // toProcess.forEach((itm) => {
    // if (itm) {
      // const itmContent = JSON.parse(itm);

      content.forEach((itm) => {
        const k = keys(itm).filter(
          (i) => has(itm[i], "fontFamily") || has(itm, "fontsUsed")
        );

        k.forEach((i) => {
          let fontFamily = "";

          // Type assertion to treat itm[i] as FontItem
          const item = itm[i] as FontItem;

          if (has(item, "fontFamily")) fontFamily = item.fontFamily;
          else if (has(item, "[0].fontFamily")) fontFamily = item[0].fontFamily;

          if (fontFamily && fontList.findIndex((ff) => ff === fontFamily))
            fontList.push(fontFamily);
        });

        // Look for & extract font-family values in itm.html
        if (itm && typeof itm.html === "string") {
          // Regex to match font-family in style attributes, e.g. font-family: poppins;
          const fontFamilyRegex = /font-family\s*:\s*([^;"]+)/gi;
          let match;
          while ((match = fontFamilyRegex.exec(itm.html)) !== null) {
            const fontFamily = match[1].trim().replace(/['"]/g, "");
            if (
              fontFamily &&
              fontList.findIndex((ff) => ff === fontFamily) === -1
            ) {
              fontList.push(fontFamily.charAt(0).toUpperCase() + fontFamily.slice(1));
            }
          }
        }
      });


    // }
  // });

  // console.log("\n\n", "Font List", uniq(fontList), "\n\n");

  return uniq(fontList);
};

export const useDimensions = () => {
  const ref = useRef<HTMLHeadingElement>(null);
  const [dimensions, setDimensions] = useState({});

  const domRectToObject = (rect: DOMRect) => {
    return {
      x: rect.x,
      y: rect.y,
      width: rect.width,
      height: rect.height,
      top: rect.top,
      right: rect.right,
      bottom: rect.bottom,
      left: rect.left,
    };
  };

  useLayoutEffect(() => {
    if (ref.current) {
      // setDimensions(ref.current.getBoundingClientRect().toJSON());
      setDimensions(domRectToObject(ref.current.getBoundingClientRect()));
    }
  }, [ref.current]);

  return [ref, dimensions];
};

export const cancelActions = (e) => {
  // e.preventDefault();
  e.stopPropagation();
  return false;
};

export const encode = (s, k) => btoa(btoa(btoa(s)));
export const decode = (s, k) => atob(atob(atob(s)));

export enum ClipPathTypes {
  TRIANGLE = "TRIANGLE",
  TRAPEZOID = "TRAPEZOID",
  PARALLELOGRAM = "PARALLELOGRAM",
  RHOMBUS = "RHOMBUS",
  PENTAGON = "PENTAGON",
  HEXAGON = "HEXAGON",
  HELPTAGON = "HELPTAGON",
  OCTAGON = "OCTAGON",
  NONAGON = "NONAGON",
  DECAGON = "DECAGON",
  BEVEL = "BEVEL",
  RABBET = "RABBET",
  LEFTARROW = "LEFTARROW",
  RIGHTARROW = "RIGHTARROW",
  LEFTPOINT = "LEFTPOINT",
  RIGHTPOINT = "RIGHTPOINT",
  LEFTCHEVRON = "LEFTCHEVRON",
  RIGHTCHEVRON = "RIGHTCHEVRON",
  STAR = "STAR",
  CROSS = "CROSS",
  MESSAGE = "MESSAGE",
  CLOSE = "CLOSE",
  FRAME = "FRAME",
  INSET = "INSET",
  CIRCLE = "CIRCLE",
  ELLIPSE = "ELLIPSE",
}

interface IClipPaths {
  type: ClipPathTypes;
}

export const getClipPath = ({ type }: IClipPaths) => {
  switch (type) {
    case ClipPathTypes.TRIANGLE:
      return `polygon(50% 0%, 0% 100%, 100% 100%);`;
    case ClipPathTypes.TRAPEZOID:
      return `polygon(20% 0%, 80% 0%, 100% 100%, 0% 100%);`;
    case ClipPathTypes.PARALLELOGRAM:
      return `polygon(25% 0%, 100% 0%, 75% 100%, 0% 100%)`;
    case ClipPathTypes.RHOMBUS:
      return `polygon(50% 0%, 100% 50%, 50% 100%, 0% 50%);`;
    case ClipPathTypes.PENTAGON:
      return `polygon(50% 0%, 100% 38%, 82% 100%, 18% 100%, 0% 38%);`;
    case ClipPathTypes.HEXAGON:
      return `polygon(50% 0%, 100% 25%, 100% 75%, 50% 100%, 0% 75%, 0% 25%);`;
    case ClipPathTypes.HELPTAGON:
      return `polygon(50% 0%, 90% 20%, 100% 60%, 75% 100%, 25% 100%, 0% 60%, 10% 20%);`;
    case ClipPathTypes.OCTAGON:
      return `polygon(30% 0%, 70% 0%, 100% 30%, 100% 70%, 70% 100%, 30% 100%, 0% 70%, 0% 30%);`;
    case ClipPathTypes.NONAGON:
      return `polygon(50% 0%, 83% 12%, 100% 43%, 94% 78%, 68% 100%, 32% 100%, 6% 78%, 0% 43%, 17% 12%);`;
    case ClipPathTypes.DECAGON:
      return `polygon(50% 0%, 80% 10%, 100% 35%, 100% 70%, 80% 90%, 50% 100%, 20% 90%, 0% 70%, 0% 35%, 20% 10%);`;
    case ClipPathTypes.BEVEL:
      return `polygon(20% 0%, 80% 0%, 100% 20%, 100% 80%, 80% 100%, 20% 100%, 0% 80%, 0% 20%);`;
    case ClipPathTypes.RABBET:
      return `polygon(0% 15%, 15% 15%, 15% 0%, 85% 0%, 85% 15%, 100% 15%, 100% 85%, 85% 85%, 85% 100%, 15% 100%, 15% 85%, 0% 85%);`;
    case ClipPathTypes.LEFTARROW:
      return `polygon(40% 0%, 40% 20%, 100% 20%, 100% 80%, 40% 80%, 40% 100%, 0% 50%)`;
    case ClipPathTypes.RIGHTARROW:
      return `polygon(0% 20%, 60% 20%, 60% 0%, 100% 50%, 60% 100%, 60% 80%, 0% 80%)`;
    case ClipPathTypes.LEFTPOINT:
      return `polygon(25% 0%, 100% 1%, 100% 100%, 25% 100%, 0% 50%)`;
    case ClipPathTypes.RIGHTPOINT:
      return `polygon(0% 0%, 75% 0%, 100% 50%, 75% 100%, 0% 100%)`;
    case ClipPathTypes.LEFTCHEVRON:
      return `polygon(100% 0%, 75% 50%, 100% 100%, 25% 100%, 0% 50%, 25% 0%)`;
    case ClipPathTypes.RIGHTCHEVRON:
      return `polygon(75% 0%, 100% 50%, 75% 100%, 0% 100%, 25% 50%, 0% 0%)`;
    case ClipPathTypes.STAR:
      return `polygon(50% 0%, 61% 35%, 98% 35%, 68% 57%, 79% 91%, 50% 70%, 21% 91%, 32% 57%, 2% 35%, 39% 35%)`;
    case ClipPathTypes.CROSS:
      return `polygon(10% 25%, 35% 25%, 35% 0%, 65% 0%, 65% 25%, 90% 25%, 90% 50%, 65% 50%, 65% 100%, 35% 100%, 35% 50%, 10% 50%)`;
    case ClipPathTypes.MESSAGE:
      return `polygon(0% 0%, 100% 0%, 100% 75%, 75% 75%, 75% 100%, 50% 75%, 0% 75%)`;
    case ClipPathTypes.CLOSE:
      return `polygon(20% 0%, 0% 20%, 30% 50%, 0% 80%, 20% 100%, 50% 70%, 80% 100%, 100% 80%, 70% 50%, 100% 20%, 80% 0%, 50% 30%)`;
    case ClipPathTypes.FRAME:
      return `polygon(0% 0%, 0% 100%, 25% 100%, 25% 25%, 75% 25%, 75% 75%, 25% 75%, 25% 100%, 100% 100%, 100% 0%)`;
    case ClipPathTypes.INSET:
      return `inset(5% 20% 15% 10%)`;
    case ClipPathTypes.CIRCLE:
      return `circle(50% at 50% 50%)`;
    case ClipPathTypes.ELLIPSE:
      return `ellipse(25% 40% at 50% 50%)`;
    default:
      return null;
  }
};

/**
 * This function takes an array of campaign variables and converts them 
 * into a simple object where each variable's ID becomes the property name 
 * and its value becomes the property value
 * @param arr - an array of objects with id and value properties
 * @returns an object with the id as the key and the value as the value
 */
export const remapCampaignVariables = (arr: Array<{ id: string; value: any }>): Record<string, any> => {
  try {
    return arr
      .filter(item => item.value !== null)
      .reduce((obj: Record<string, any>, item: { id: string; value: any }) => {
        obj[item.id] = item.value;
        if (item.id === "colors") obj.color = item.value; // remap colors to color (for legacy support)
        return obj;
      }, {});
  } catch (err) {
    return {};
  }
};

/**
 * This function takes an object and converts it into an array of objects 
 * with id and value properties. It is the inverse of remapCampaignVariables.
 * @param obj - an object with the id as the key and the value as the value
 * @returns an array of objects with id and value properties
 */
export const unmapCampaignVariables = (obj: Record<string, any>): Array<{ id: string; value: any }> => {
  try {
    return Object.entries(obj)
      .filter(([_, value]) => value !== null)
      .map(([id, value]) => ({
        id,
        value
      }));
  } catch (err) {
    return [];
  }
};

export const convertPagetoHTML = (obj: ISettings[]) => {
  return ReactDOMServer.renderToStaticMarkup(
    React.createElement(
      PageContext.Provider,
      {
        value: {
         campaignSettings: {},
         parseLiquid: true,
        }
      },
      React.createElement(PageContent, {
        id: "agent-generated-page",
        content: JSON.stringify(obj),
        nextPage: "#",
        getPageData: () => {},
        trackingPayload: "",
        seoPayload: "",
        merchantPayload: "", 
        emailPayload: "",
        cssPayload: "",
        exitPayload: "",
        objectId: "cm4kr8rtd26ve08110cbkd5yh",
        campaignId: "cm4kr8r4f26uz0811dhydieos",
        userId: "cjyuon38x00fa0792wzw2v1lu"
      })
    )
  );
}

export const remapColor = (color: string, type: ComponentTypes) => {
  // For sections, containers, rows, and column
  // - change black `#141414` or `rgb(20,20,20)` to `inverseSurface`
  // - change dark gray `#202A37`  or  `rgb(32,42,55)` to `surfaceContainerHigh`
  // - change gray `#4B5562` or `rgb(75,85,98)` to `surfaceContainer`
  // - change light `#F9FAFB` or `rgb(249,250,251)` to `surfaceContainerLow`
  // - change lightest `#FFFFFF` or `rgb(255,255,255)` to `surface`
  if (type === ComponentTypes.SECTION || type === ComponentTypes.CONTAINER || type === ComponentTypes.COLUMNS || type === ComponentTypes.COLUMN) {
    if (color === "#141414" || color === "rgb(20,20,20)" || color === "rgb(20,20,20,1)" || color === "#000000" || color === "rgb(0,0,0)" || color === "#000") {
      return "inverseSurface";
    } else if (color.toUpperCase() === "#202A37" || color === "rgb(32,42,55)" || color === "rgb(32,42,55,1)") {
      return "surfaceContainerHigh";
    } else if (color.toUpperCase() === "#4B5562" || color === "rgb(75,85,98)" || color === "rgb(75,85,98,1)" || color === "#666666" || color === "rgb(102,102,102)" || color === "rgb(102,102,102,1)") {
      return "surfaceContainer";
    } else if (color.toUpperCase() === "#F9FAFB" || color === "rgb(249,250,251)" || color === "rgb(249,250,251,1)") {
      return "surfaceContainerLow";
    } else if (color.toUpperCase() === "#FFFFFF" || color === "rgb(255,255,255)" || color === "rgb(255,255,255,1)") {
      return "surface";
    }
  }

  // for buttons, icons, and svg's, set background color and color property to
		// - change black `#141414` or `rgb(20,20,20)` or dark gray `#202A37` or `rgb(32,42,55)` to `primary` 
		// - change gray `#4B5562` or `rgb(75,85,98)` to `secondary`
  if (type === ComponentTypes.BUTTON || type === ComponentTypes.V1BUTTON || type === ComponentTypes.ICON || type === ComponentTypes.IMAGE || type === ComponentTypes.PICTURE) {
    if (color === "#141414" || color === "rgb(20,20,20)" || color === "rgb(20,20,20,1)" || color === "#000000" || color === "rgb(0,0,0)" || color === "#000") {
      return "primary";
    } else if (color.toUpperCase() === "#4B5562" || color === "rgb(75,85,98)" || color === "rgb(75,85,98,1)") {
      return "secondary";
    } else if (color.toUpperCase() === "#F9FAFB" || color === "rgb(249,250,251)" || color === "rgb(249,250,251,1)") {
      return "surfaceContainerLow";
    } else if (color.toUpperCase() === "#FFFFFF" || color === "rgb(255,255,255)" || color === "rgb(255,255,255,1)") {
      return "surface";
    }
  }

  return false;
}

// Abstracted function to handle color remapping for any component
const remapComponentColors = (itm: any, type: ComponentTypes) => {
  const logPrefix = `${type} (${itm?.id})`;
  let newItm = itm;
  let hasChanges = false;

  // Define the color mapping configuration for each component type (FIRST ROUND - SURFACES ONLY)
  const colorConfigs = {
    [ComponentTypes.SECTION]: { propertyPaths: ['properties.backgroundColor'] },
    [ComponentTypes.CONTAINER]: { propertyPaths: ['properties.backgroundColor'] },
    [ComponentTypes.COLUMNS]: { propertyPaths: ['properties.backgroundColor'] },
    [ComponentTypes.COLUMN]: { propertyPaths: ['properties.backgroundColor'] },
    [ComponentTypes.BUTTON]: { propertyPaths: ['properties.backgroundColor'] },
    [ComponentTypes.V1BUTTON]: { propertyPaths: ['properties.backgroundColor'] },
    [ComponentTypes.ICON]: { propertyPaths: ['properties.color'] },
    [ComponentTypes.IMAGE]: { propertyPaths: ['src'], isSvgFill: true },
    [ComponentTypes.PICTURE]: { propertyPaths: ['src'], isSvgFill: true },
    [ComponentTypes.COUNTDOWN]: { 
      propertyPaths: [
        'properties.backgroundColor',
        'properties.color', 
        'labelStyle.color',
        'numberStyle.color',
        'numberStyle.backgroundColor'
      ]
    },
    // NOTE: TEXT, HEADLINE, LIST, LISTITEM are NOT included here - they go in second round
  };
  
  console.log('First round configs:', Object.keys(colorConfigs));

  const config = colorConfigs[type];
  if (!config) {
    console.log(`First round: Skipping ${type} (${itm?.id}) - no config for surface mapping`);
    return itm;
  }
  
  console.log(`First round: Processing ${type} (${itm?.id}) with config:`, config);

  // Process all property paths (single or multiple)
  config.propertyPaths.forEach(propertyPath => {
    const color = get(itm, propertyPath);
    
    if (config.isHtmlColor && color) {
      console.log(`First round: Found HTML color processing for ${type} (${itm?.id}) - this shouldn't happen!`);
      // Handle HTML color extraction (for TEXT and HEADLINE)
      const match = color.match(/color: #([0-9a-fA-F]{6})/);
      const extractedColor = match ? `#${match[1]}` : null;
      if (extractedColor && remapColor(extractedColor, type)) {
        const remappedColor = remapColor(extractedColor, type);
        const newHtml = color.replace(
          /color: #([0-9a-fA-F]{6})/g, 
          `color: {{ color.${remappedColor} | default: '#$1' }}`
        );
        newItm = set(newItm, propertyPath, newHtml);
        console.log(logPrefix, 'html color', extractedColor, 'remapped to', remappedColor, 'newItm', newItm);
        hasChanges = true;
      } else {
        console.log(logPrefix, 'html color', extractedColor);
      }
    } else if (config.isSvgFill && color && color.includes("<svg")) {
      // Handle SVG fill colors (for IMAGE and PICTURE)
      const fillMatches = color.match(/fill="([^"]+)"/g);
      if (fillMatches) {
        let updatedSvg = color;
        let hasSvgChanges = false;
        
        // Extract unique color values and process them
        const uniqueColors = [...new Set(fillMatches.map(match => match.match(/fill="([^"]+)"/)?.[1]))];
        
        uniqueColors.forEach(colorValue => {
          if (colorValue && colorValue !== 'none' && remapColor(colorValue, type)) {
            const remappedColor = remapColor(colorValue, type);
            // Replace all instances of this color in the SVG
            const regex = new RegExp(`fill="${colorValue.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}"`, 'g');
            updatedSvg = updatedSvg.replace(regex, `fill="{{ color.${remappedColor} | default: '${colorValue}' }}"`);
            hasSvgChanges = true;
            console.log(logPrefix, 'svg color', colorValue, 'remapped to', remappedColor);
          }
        });
        
        if (hasSvgChanges) {
          newItm = set(newItm, propertyPath, updatedSvg);
          hasChanges = true;
          console.log(logPrefix, 'svg updated with remapped colors', updatedSvg);
        }
        
        console.log(logPrefix, 'svg colors found', uniqueColors);
      }
    } else if (color && remapColor(color, type)) {
      // Handle regular color properties
      const remappedColor = remapColor(color, type);
      newItm = set(newItm, propertyPath, `{{ color.${remappedColor} | default: '${color}' }}`);
      console.log(logPrefix, 'color', color, 'remapped to', remappedColor, 'newItm', newItm);
      hasChanges = true;
    } else {
      console.log(logPrefix, 'color', color);
    }

    // Handle mobile properties if they exist (automatically detected)
    // Only process mobile for properties that are under 'properties' (not for iconStyle, labelStyle, etc.)
    if (propertyPath.startsWith('properties.') && newItm?.properties?.mobile) {
      const mobile = newItm.properties.mobile;
      const mobileUpdates: Record<string, any> = {};
      let hasMobileChanges = false;

      Object.entries(mobile).forEach(([key, properties]: any) => {
        if (properties) {
          // Extract the property name from the config path (e.g., 'properties.backgroundColor' -> 'backgroundColor')
          const propertyName = propertyPath.split('.').slice(1).join('.');
          const mobileColor = get(properties, propertyName);
          
          if (mobileColor && remapColor(mobileColor, type)) {
            const remappedColor = remapColor(mobileColor, type);
            mobileUpdates[key] = {
              ...properties,
              [propertyName]: `{{ color.${remappedColor} | default: '${mobileColor}' }}`
            };
            hasMobileChanges = true;
            console.log(logPrefix, 'mobile color', mobileColor, 'remapped to', remappedColor);
          }
        }
      });

      if (hasMobileChanges) {
        newItm = {
          ...newItm,
          properties: {
            ...newItm.properties,
            mobile: { ...mobile, ...mobileUpdates }
          }
        };
        hasChanges = true;
      }
    }
  });

  // Log all colors for components with multiple properties (like COUNTDOWN)
  if (config.propertyPaths.length > 1) {
    const colors = config.propertyPaths.map(path => get(itm, path));
    console.log(logPrefix, ...config.propertyPaths.map((path, i) => [path, colors[i]]).flat());
  }

  if (hasChanges) console.log(logPrefix, 'has changes', 'newItm', newItm);

  return hasChanges ? newItm : itm;
};

export const mapColorsToVariables = (content: ISettings[]) => {
  // FIRST ROUND: Only process surface components (sections, containers, buttons, icons, etc.)
  const newContent = content.map(itm => {
    const { type } = itm;
    const result = remapComponentColors(itm, type);
    if (result !== itm) {
      console.log(`First round processed: ${type} (${itm?.id})`);
    }
    return result;
  });

  // Create a deep copy to preserve the state after first round
  const newContentAfterFirstRound = JSON.parse(JSON.stringify(newContent));
  console.log('newContent (after first round - surfaces only)', newContentAfterFirstRound);
  
  // Debug: Check if any text elements have been modified in the first round
  newContentAfterFirstRound.forEach(item => {
    if (item.type === 'Headline' || item.type === 'Text') {
      if (item.html && item.html.includes('{{ color.')) {
        console.log(`WARNING: ${item.type} (${item.id}) has liquid variables after first round - this shouldn't happen!`);
        console.log('HTML:', item.html);
      }
    }
  });

  // SECOND ROUND: Only process text elements for "on" surface colors
  const newContent2 = newContent.map(itm => {
    const { type } = itm;
    const result = remapOnSurfaceColors(newContent, itm, type);
    if (result !== itm) {
      console.log(`Second round processed: ${type} (${itm?.id})`);
    }
    return result;
  });

  console.log('newContent2 (after second round - text elements)', newContent2);

  return newContent2;
}

// Function to get the "on" surface color based on a surface color variable
const getOnSurfaceColor = (surfaceColorVariable: string): string => {
  // Map surface colors to their corresponding "on" surface colors
  const onSurfaceMap = {
    'primary': 'onPrimary',
    'secondary': 'onSecondary', 
    'surface': 'onSurface',
    'surfaceContainer': 'onSurfaceContainer',
    'surfaceContainerHigh': 'onSurfaceContainerHigh',
    'surfaceContainerLow': 'onSurfaceContainerLow',
    'inverseSurface': 'onInverseSurface'
  };
  
  return onSurfaceMap[surfaceColorVariable] || 'onSurface';
};

// Function to extract color variable from a remapped color string
const extractColorVariable = (remappedColor: string): string | null => {
  const match = remappedColor.match(/{{ color\.([^}]+) \| default:/);
  return match ? match[1] : null;
};

// Function to find the closest ancestor with a surface color that has a liquid variable
const findClosestSurfaceAncestor = (content: any[], itemId: string): any => {
  const ancestors = listAncestors(content, itemId);
  if (!ancestors) return null;
  
  // Look for the closest ancestor that's a surface component AND has a liquid variable
  const surfaceTypes = [
    ComponentTypes.SECTION, 
    ComponentTypes.CONTAINER, 
    ComponentTypes.COLUMNS, 
    ComponentTypes.COLUMN
  ];
  
  // Find the closest ancestor that is a surface component AND has a liquid variable
  for (const ancestor of ancestors) {
    if (surfaceTypes.includes(ancestor.type)) {
      const surfaceColorVar = getSurfaceColorVariable(ancestor);
      if (surfaceColorVar) {
        console.log(`Found closest surface ancestor with liquid variable: ${ancestor.type} (${ancestor.id}) with color: ${surfaceColorVar}`);
        return ancestor;
      }
    }
  }
  
  console.log(`No surface ancestor with liquid variable found for item ${itemId}`);
  return null;
};

// Function to get the surface color variable from an item
const getSurfaceColorVariable = (item: any): string | null => {
  // PRIORITY 1: Check mobile properties for backgroundColor with liquid variables (highest priority)
  if (item?.properties?.mobile) {
    const mobile = item.properties.mobile;
    
    // Check each mobile breakpoint
    for (const [breakpoint, properties] of Object.entries(mobile)) {
      if (properties?.backgroundColor) {
        const bgColor = properties.backgroundColor;
        const colorVar = extractColorVariable(bgColor);
        if (colorVar) {
          console.log(`Found surface color variable in mobile.${breakpoint}.backgroundColor:`, colorVar);
          return colorVar;
        }
      }
    }
  }
  
  // PRIORITY 2: Check main backgroundColor (lower priority)
  if (item?.properties?.backgroundColor) {
    const bgColor = item.properties.backgroundColor;
    const colorVar = extractColorVariable(bgColor);
    if (colorVar) {
      console.log(`Found surface color variable in main backgroundColor:`, colorVar);
      return colorVar;
    }
  }
  
  return null;
};

// Function to remap "on" surface colors for text elements
const remapOnSurfaceColors = (content: any[], itm: any, type: ComponentTypes) => {
  const logPrefix = `${type} (${itm?.id})`;
  let newItm = itm;
  let hasChanges = false;

  // Define which components need "on" surface color mapping (SECOND ROUND - TEXT ELEMENTS ONLY)
  const onSurfaceConfigs = {
    [ComponentTypes.TEXT]: { propertyPaths: ['html'], isHtmlColor: true },
    [ComponentTypes.HEADLINE]: { propertyPaths: ['html'], isHtmlColor: true },
    [ComponentTypes.LIST]: { propertyPaths: ['properties.color'] },
    [ComponentTypes.LISTITEM]: { propertyPaths: ['iconStyle.color'] },
    [ComponentTypes.BUTTON]: { 
      propertyPaths: ['caption1style.color', 'caption2style.color'],
      useSelfAsParent: true 
    },
    [ComponentTypes.V1BUTTON]: { 
      propertyPaths: ['caption1style.color', 'caption2style.color'],
      useSelfAsParent: true 
    },
    [ComponentTypes.ADVANCEDBUTTON]: { 
      propertyPaths: ['caption1style.color', 'caption2style.color'],
      useSelfAsParent: true 
    }
  };

  const config = onSurfaceConfigs[type];
  if (!config) {
    console.log(`Second round: Skipping ${type} (${itm?.id}) - no config for on-surface mapping`);
    return itm;
  }
  
  console.log(`Second round: Processing ${type} (${itm?.id}) with config:`, config);

  // Determine the parent surface color
  let parentSurfaceColor: string | null = null;
  
  if (config.useSelfAsParent) {
    // For buttons, use their own backgroundColor
    parentSurfaceColor = getSurfaceColorVariable(itm);
  } else {
    // For text elements, find closest surface ancestor
    const surfaceAncestor = findClosestSurfaceAncestor(content, itm.id);
    if (surfaceAncestor) {
      parentSurfaceColor = getSurfaceColorVariable(surfaceAncestor);
    }
  }

  if (!parentSurfaceColor) {
    console.log(logPrefix, 'no parent surface color found, using default onSurface');
    parentSurfaceColor = 'surface'; // fallback
  }

  const onSurfaceColor = getOnSurfaceColor(parentSurfaceColor);
  console.log(logPrefix, 'parent surface color:', parentSurfaceColor, 'on surface color:', onSurfaceColor);

  // Process each property path
  config.propertyPaths.forEach(propertyPath => {
    const color = get(itm, propertyPath);
    console.log(`Second round: Processing ${type} (${itm?.id}) property ${propertyPath} with color:`, color);
    
    // Debug: Let's see what the actual object structure looks like
    if (propertyPath.includes('caption') && !color) {
      console.log(`Debug: ${type} (${itm?.id}) object structure:`, itm);
      console.log(`Debug: caption1style:`, itm.caption1style);
      console.log(`Debug: caption2style:`, itm.caption2style);
    }
    
    if (config.isHtmlColor && color) {
      // Handle HTML color extraction (for TEXT and HEADLINE)
      const match = color.match(/color: #([0-9a-fA-F]{6})/);
      const extractedColor = match ? `#${match[1]}` : null;
      if (extractedColor) {
        // Always apply "on" surface color, regardless of whether original color was remappable
        const newHtml = color.replace(
          /color: #([0-9a-fA-F]{6})/g, 
          `color: {{ color.${onSurfaceColor} | default: '#$1' }}`
        );
        newItm = set(newItm, propertyPath, newHtml);
        console.log(logPrefix, 'html color', extractedColor, 'remapped to on surface color', onSurfaceColor);
        hasChanges = true;
      }
    } else if (color) {
      // Always apply "on" surface color, regardless of whether original color was remappable
      newItm = set(newItm, propertyPath, `{{ color.${onSurfaceColor} | default: '${color}' }}`);
      console.log(logPrefix, 'color', color, 'remapped to on surface color', onSurfaceColor);
      hasChanges = true;
    }
  });

  return hasChanges ? newItm : itm;
};

// const colorMap = {
//   "inverseSurface": "#141414",
//   "surfaceContainerHigh": "#202A37",
//   "surfaceContainer": "#4B5562",
//   "surfaceContainerLow": "#F9FAFB",
//   "surface": "#FFFFFF",
//   "primary": "#141414",
//   "secondary": "#4B5562"
// }